// useRenderCounts.ts
import { Subscription } from 'rxjs';
import { useEffect, useState } from 'react';

import { renderTracking } from './render-tracking-service';

export const useRenderTracking = (componentName?: string): number | Record<string, number> => {
	const [counts, setCounts] = useState<Record<string, number>>({});

	useEffect(() => {
		const sub: Subscription = renderTracking.getRenderCounts$().subscribe(setCounts);
		return () => sub.unsubscribe();
	}, []);

	if (componentName) {
		return counts[componentName] ?? 0;
	}

	return counts;
};
